import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { ordersForSuppliersRequest, ordersForSuppliersRequestError, ordersForSuppliersRequestSuccess } from "../../slices/Dashboard/ordersForSuppliersSlice";

export const OrdersForSuppliersAPI = () => async (dispatch) => {
    try {
        dispatch(ordersForSuppliersRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getOrdersForSuppliers,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(ordersForSuppliersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(ordersForSuppliersRequestError(_error));
            });
    } catch (error) { }
};
